import React from 'react';
import { inputStyles } from './FormStyles';

const TextElementForm = ({ textElement, onElementChange, elementKey }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block">
            <span className={inputStyles.label}>Font Family</span>
            <select
              className={inputStyles.select}
              value={textElement.fontFamily}
              onChange={(e) => onElementChange(elementKey, 'fontFamily', e.target.value)}
            >
              <option value="Roboto">Roboto</option>
              <option value="Lato">Lato</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Open Sans">Open Sans</option>
              <option value="Arial">Arial</option>
            </select>
          </label>
        </div>

        <div>
          <label className="block">
            <span className={inputStyles.label}>Font Style</span>
            <select
              className={inputStyles.select}
              value={textElement.fontStyle}
              onChange={(e) => onElementChange(elementKey, 'fontStyle', e.target.value)}
            >
              <option value="normal">Normal</option>
              <option value="bold">Bold</option>
              <option value="italic">Italic</option>
              <option value="bold italic">Bold Italic</option>
            </select>
          </label>
        </div>
      </div>

      <div>
        <label className="block">
          <span className={inputStyles.label}>Text Color</span>
          <div className="mt-2 flex items-center gap-2">
            <input
              type="color"
              className={inputStyles.colorInput}
              value={textElement.color}
              onChange={(e) => onElementChange(elementKey, 'color', e.target.value)}
            />
            <span className="text-sm text-gray-500">{textElement.color}</span>
          </div>
        </label>
      </div>

      <div>
        <label className="block">
          <span className={inputStyles.label}>Font Size</span>
          <input
            type="range"
            min="10"
            max="100"
            value={textElement.fontSize}
            onChange={(e) => onElementChange(elementKey, 'fontSize', parseInt(e.target.value))}
            className="w-full"
          />
          <span className="text-sm text-gray-500">{textElement.fontSize}px</span>
        </label>
      </div>
    </div>
  );
};

export default TextElementForm;
